import LonzaLanding from './LonzaModule';

export default LonzaLanding;
